const DropDownList = {
    religion: [
        "Not Willing to Disclose",
        "Hindu",
        "Christian",
        "Muslim",
        "Jainism",
        "Sikh",
        "Buddhism",
        "Others",
    ],
    communities: {
        Hindu: [
            "Hindu BC - Others",
            "Hindu MBC",
            "Hindu ST",
            "Hindu SC - Others",
            "Hindu SC - Arunthathiyar",
            "Hindu OC",
            "Hindu DNC (Denotified Communities)",
            "Hindu No Community",
        ],
        Christian: [
            "Christian BC - Others",
            "Christian MBC",
            "Christian OC",
            "Christian DNC (Denotified Communities)",
            "Christian ST",
            "Christian No Community",
        ],
        Buddhism: [
            "Buddhism BC - Others",
            "Buddhism MBC",
            "Buddhism ST",
            "Buddhism SC - Others",
            "Buddhism SC - Arunthathiyar",
            "Buddhism OC",
            "Buddhism DNC (Denotified Communities)",
            "Buddhism No Community",
        ],
        Muslim: [
            "Muslim BC - Muslim",
            "Muslim OC",
            "Muslim No Community",
        ],
        Jainism: [
            "Jainism OC",
            "Jainism No Community",
        ],
        Sikh: [
            "Sikh BC - Others",
            "Sikh MBC",
            "Sikh SC - Others",
            "Sikh OC",
            "Sikh No Community",
        ],
        Others: [
            "Others BC - Others",
            "Others MBC",
            "Others ST",
            "Others SC - Others",
            "Others SC - Arunthathiyar",
            "Others OC",
            "Others DNC (Denotified Communities)",
            "Others No Community",
        ],
    },
    motherTongue: [
        "Tamil",
        "Malayalam",
        "Kannada",
        "Telugu",
        "Gujarati",
        "Hindi",
        "Assamese",
        "English",
        "Urdu",
    ],
    bloodGroup: [
        "A+ve",
        "A-ve",
        "B+ve",
        "B-ve",
        "AB+ve",
        "AB-ve",
        "O+ve",
        "O-ve",
        "A1+ve",
        "A1-ve",
        "A1B+ve",
        "A1B-ve",
        "A2+ve",
        "A2-ve",
        "A2B+ve",
        "A2B-ve",
        "B1+ve",
    ],
    state: [
        "Andhra Pradesh",
        "Arunachal Pradesh",
        "Assam",
        "Bihar",
        "Chhattisgarh",
        "Goa",
        "Gujarat",
        "Haryana",
        "Himachal Pradesh",
        "Jharkhand",
        "Karnataka",
        "Kerala",
        "Madhya Pradesh",
        "Maharashtra",
        "Manipur",
        "Meghalaya",
        "Mizoram",
        "Nagaland",
        "Odisha",
        "Punjab",
        "Rajasthan",
        "Sikkim",
        "Tamil Nadu",
        "Telangana",
        "Tripura",
        "Uttar Pradesh",
        "Uttarakhand",
        "West Bengal",
    ],
    qualification: [
        "SSLC",
        "PUC",
        "Higher Secondary",
        "Graduate",
        "Post Graduate",
        "M.Phil",
        "Ph.D",
        "Post - Doctoral",
        "VIII Passes",
        "Literate In Tamil (No Schooling)",
        "No Formal Schooling",
        "V Passes",
    ],
    organization: [
        "Government",
        "Private Sector",
        "Self - Employed",
        "Daily Wages",
        "Un - Employed",
        "N/A",
    ],
    designation: [
        "General Corporate Designations",
        "IT & Software Designations",
        "Human Resources Designations",
        "Marketing & Sales Designations",
        "Finance & Accounting Designations",
        "Creative & Design Roles",
        "Healthcare Designations",
        "Academic & Research Designations",
    ],
    annualIncome: [
        "0 to 12000",
        "12001 - 24000",
        "24001 - 50000",
        "50001 - 100000",
        "100001 - 200000",
        "200001 - 250000",
        "250001 - 400000",
        "400001 - 500000",
        "500001 - 600000",
        "600001 - 800000",
        "800001 - 1000000",
        "1000001 - 1500000",
        "1500000 and Above",
    ],
    relationship: [
        "Grandfather",
        "Grandmother",
        "Brother",
        "Sister",
        "Uncle",
        "Aunty",
        "Legal Guardian",
        "Caretaker",
        "Other",
    ],
    
};

export default DropDownList;
